<template>
  <div v-if="this.type == 'aircon'">
    <Aircon v-if="this.calldata[0]" :calldata="this.calldata" :type="this.type" :sensorid="this.sensorid"/>
  </div>
  <div v-else-if="this.type == 'relay'">
    <Relay :type="this.type" />
  </div>
  <div v-else>
     <vs-row class="mb-3 ml-2" >
      <vs-button color="dark" disabled type="flat"><h5>Device Management / </h5></vs-button>
     <vs-button type="flat" to="/sensor"> <h5>Sensor</h5></vs-button>
     <vs-button  color="dark" disabled type="flat"><b><h5>/ View Sensor</h5></b> </vs-button>
    </vs-row>
    <vs-row vs-w="12" v-if="this.username != 'poonsak.ngk'">
  <vs-col  vs-lg="12" vs-xs="12" >
   <vs-card style="border-radius: 20px;">
       <div class="mt-2" slot="header">
          <h4 >
            {{sensorname}}
          </h4>
        </div>
     <vs-row vs-w="12">
  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="5" vs-sm="12" vs-xs="12" >
    <img src="../../../assets/images/sensor/sensor.jpg"  width="250" height="100">
  </vs-col>
  <vs-col vs-type="flex" vs-align="center"  vs-lg="7" vs-sm="12" vs-xs="12">
    <!-- <ul>
      <p class="mt-3 mb-2">Name : {{sensorname}}</p>
      <p class="mt-3 mb-2">Serial Number : {{sensorid}}</p>
      <p class="mt-3 mb-2">Type : {{type}}</p>
      <p class="mt-3 mb-2">Network : {{nwname}}</p>
      <p class="mt-3 mb-2">Location : Unavailable</p>
      <p v-if="statussensor || type == 'control'" class="mt-3 mb-2">Status :  Active</p>
      <p v-else class="mt-3 mb-2">Status :  Inactive</p>
      
    </ul> -->
    <!-- <b-table stacked :items="items"></b-table> -->
            <div style="width: 100%">
              <vs-row  vs-w="12">
                <vs-col class="textRight textResponsive"  vs-lg="3" vs-sm="4" vs-xs="3" >
                  <h6 class="font-weight-bold">Name </h6> 
                </vs-col>
                <vs-col  vs-lg="8" vs-sm="8" vs-xs="9">
                <h6 class="ml-1">{{sensorname}}</h6> 
                </vs-col>
              </vs-row>
              <vs-row class="mt-3"  vs-w="12">
                <vs-col  class="textRight textResponsive" vs-lg="3" vs-sm="4" vs-xs="3" >
                  <h6 class="font-weight-bold">Serial Number </h6> 
                </vs-col>
                <vs-col  vs-lg="8" vs-sm="8" vs-xs="9">
                <h6 class="ml-1">{{sensorid}}</h6> 
                </vs-col>
              </vs-row>
              <vs-row class="mt-3" vs-w="12">
                <vs-col  class="textRight textResponsive"  vs-lg="3" vs-sm="4" vs-xs="3" >
                  <h6 class="font-weight-bold">Type </h6>
                </vs-col>
                <vs-col vs-lg="8" vs-sm="8" vs-xs="9">
                  <h6 class="ml-1">{{type}}</h6>
                </vs-col>
              </vs-row>
              <vs-row class="mt-3" vs-w="12">
                <vs-col  class="textRight textResponsive"  vs-lg="3" vs-sm="4" vs-xs="3" >
                  <h6 class="font-weight-bold">Network </h6>
                </vs-col>
                <vs-col vs-lg="8" vs-sm="8" vs-xs="9">
                  <h6 class="ml-1">{{nwname}}</h6>
                </vs-col>
              </vs-row>
             <vs-row  v-if="statussensor || type == 'control'" class="mt-3" vs-w="12">
                <vs-col  class="textRight textResponsive"  vs-lg="3" vs-sm="4" vs-xs="3" >
                  <h6 class="font-weight-bold">Status </h6>
                </vs-col>
                <vs-col vs-lg="8" vs-sm="8" vs-xs="9">
                  <h6 class="ml-1">Active</h6>  
                </vs-col>
              </vs-row>
              <vs-row  v-else class="mt-3" vs-w="12">
                <vs-col  class="textRight textResponsive"  vs-lg="3" vs-sm="4" vs-xs="3" >
                  <h6 class="font-weight-bold">Status </h6>
                </vs-col>
                <vs-col vs-lg="8" vs-sm="8" vs-xs="9">
                  <h6 class="ml-1">Inactive</h6>  
                </vs-col>
              </vs-row>
            </div>
  </vs-col>
</vs-row>
     
     </vs-card>
     </vs-col>
     </vs-row>
    <vs-card v-if="this.type == 'control'">
      <h4 class="card-title d-flex">Control Status</h4>
    </vs-card>
   
    <vs-row v-if="this.type == 'control'">
      <Control v-if="this.calldata[0]" :id="this.sensorid" :gid="this.gatewayid" :nwid="this.nwid" :nwname="this.nwname" :type="this.type" />
    </vs-row>
   
      <!-- <vs-button type="filled" icon="keyboard_backspace" color="#333f50" @click="back()">Back</vs-button> -->
    
    <!-- <vs-col vs-lg="6" vs-xs="12">
      <AlertState v-if="this.calldata[0]" :id="this.sensorid" :calldata="this.calldata" :nwid="this.nwid" :nwname="this.nwname" :type="this.type" />
    </vs-col> -->
    <vs-col vs-lg="12" vs-xs="12">
      <Lastest v-if="this.calldata[0]" :id="this.sensorid" :calldata="this.calldata" :nwid="this.nwid" :nwname="this.nwname" :type="this.type" />
    </vs-col>
      <vs-row vs-w="12">
  <vs-col  vs-lg="12" vs-xs="12" v-if="this.calldata[0]">
   <vs-card style="border-radius: 20px;">
      <vs-tabs v-if="this.username != 'poonsak.ngk'">
      <vs-tab label="History Log">
        <div class="con-tab-ejemplo mt-4">
          <State v-if="this.calldata[0]" :name="this.sensorname" :id="this.sensorid" :calldata="this.calldata" :nwid="this.nwid" :nwname="this.nwname" :type="this.type" />
        </div>
      </vs-tab>
      <vs-tab label="Chart Data">
        <div class="con-tab-ejemplo mt-4">
          <Data v-if="this.calldata[0]" :id="this.sensorid" :calldata="this.calldata" :type="this.type" :gid="this.gatewayid" :lora="this.lora"/>
        </div>
      </vs-tab>
       <vs-tab label="Alert">
        <div class="con-tab-ejemplo mt-4">
          <vs-row>
    <vs-col>
       <vs-row class="mb-3 mt-2" >
        <h4 >Alert</h4> 
        
          </vs-row>
    <div class="table-responsive">
      <vs-table  :data="alerthlistdata"
        style="color: #333f50">
      <template slot="thead">
        <vs-th style="padding: 0px;" v-for="(head,indexh) in alertheaderlist" :key="indexh">
          {{head}}
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td >
           {{data[indextr].alertname}}
          </vs-td>
          <vs-td >
            <p  v-for="(condition,index) in condata" :key="index">
                {{condition.con}} {{condition.value}}
            </p>
            
          </vs-td>
          <vs-td >
             {{data[indextr].sensorname}}
          </vs-td>
           <vs-td >
              {{data[indextr].date}}
          </vs-td> 
          <vs-td >
             <span v-if="data[indextr].status==true" >Active</span>
             <span v-if="data[indextr].status==false" >Deactive</span>
               
          </vs-td>
          <vs-td >
           <!-- {{data[indextr].ReadingData}} -->
          </vs-td>
          <vs-td >
           {{data[indextr].massage}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    </div>
    </vs-col>
  </vs-row>
        </div>
      </vs-tab>
    </vs-tabs>
      <vs-tabs v-else>
      <vs-tab label="History Log">
        <div class="con-tab-ejemplo mt-4">
          <State v-if="this.calldata[0]" :name="this.sensorname" :id="this.sensorid" :calldata="this.calldata" :nwid="this.nwid" :nwname="this.nwname" :type="this.type" />
        </div>
      </vs-tab>
      <vs-tab label="Chart Data">
        <div class="con-tab-ejemplo mt-4">
          <Data v-if="this.calldata[0]" :id="this.sensorid" :calldata="this.calldata" :type="this.type" :gid="this.gatewayid" :lora="this.lora"/>
        </div>
      </vs-tab>
    </vs-tabs>
   </vs-card>
  </vs-col>
  
</vs-row>
   
  
  </div>
</template>
<script>
import Data from "../dashboard/Sensor/Data";
import State from "../dashboard/Sensor/State";
import Control from "../dashboard/Sensor/Control"
import Lastest from "../dashboard/Sensor/Lastest"
import Aircon from '../dashboard/Sensor/Aircon.vue';
import Relay from '../dashboard/Sensor/Relay.vue';

export default {
  name: "SensorDashboard",
  props: [
    'name',
    'mode'
  ],
  components: {
    Aircon,
    Relay,
    Data,
    State,
    Control,
    Lastest,
  },
  data: () => ({
    nwid: '',
    alertlog:'',
    nwname: '',
    username: '',
    sensorname: '',
    statussensor: '',
    sensorid: '',
    gatewayid: '',
    idsensor:'',
    type: '',
    fan: '',
    condata:[],
    temp:0,
    alerthlistdata:[],
    alertheaderlist: [	"Alert Name"	,"Condition"	,"Sensor Name"	,"Alert Timestamp"	,"Status","Reading Data"	," Massage"],
    options1: ['Min','Low','Medium','High','Max','Auto'],
    options2: ['Off','Auto','Cool','Heat','Dry','Fan'],
    airmode: '',
    random: [],
    random2: [],
    calldata: [],
    count: [],
    sensdata: [{}],
    maxcount: 0,
    lora: ''
  }),
  methods: {
    statechange(bool) {
      this.$http.post(this.$url+'updatestate/'+this.sensorid, {
        Protocol: this.calldata[0].protocol,
        Power: bool,
        Mode: this.airmode,
        Temp: this.temp,
        Fan: this.fan,
        state: true
      })
    },
    Test() {
      this.State += 1
    },
    back() {
      this.$router.push({
      name: 'ViewNetwork',
      params: {
        name: this.nwname,
        id: this.nwid,
        }
      })
    },
    Max(num) {
      if(this.maxcount <= num)
      this.maxcount = num
    }
  },
  mounted() {
    this.nwname = this.$session.get('nwname')
    this.nwid = this.$session.get('nwid')
    this.sensorname = this.$session.get('sensorname')
    this.sensorid = this.$session.get('sensorid')
    this.gatewayid = this.$session.get('gatewayid')
    this.statussensor = this.$session.get('statussensor')
    this.type = this.$session.get('type')
    this.lora = this.$session.get('lora') 
    this.idsensor = this.$session.get('idsensor') 
    this.username = this.$session.get('username')
    console.log(this.nwname,this.nwid,this.sensorid,this.gatewayid,this.type,this.lora,this.sensorname,this.username,this.mode)
    this.$vs.loading()
    
    // this.$http.get(this.$url2+'getsensoralertlog/'+this.sensorid+'/'+this.username).then((result) => {
    //   // console.log(result.data)
    //   this.alerthlistdata = result.data
    // })
    //this.alertlog =this.$url2+'getsensoralertlog/'+this.idsensor +'/'+this.username
    //// console.log(this.alertlog)
    //this.$http.get(this.$url2+'getsensoralertlog/'+this.idsensor +'/'+this.username).then((result)=>{

    this.$http.get(this.$url2+'getsensoralertlog/'+this.idsensor +'/'+this.username).then((result)=>{
      // console.log(result.data)
      result.data.forEach(element => {
      this.alerthlistdata.push({alertname: element.name,condition: element.con,date: element.date,sensorname: element.sensorname,
                                massage: element.alertlog, status: element.alertstatus})
      this.condata = element.con
      // console.log(this.condata[0])
        });
    }).catch((err) => {
      console.log(err)
    })

    if(this.mode == 1) {
      if(this.type != 'aircon')
      this.$vs.loading()
      this.$http.post(this.$url+'sensorname', {
        name: this.name
      }).then((result) => {
        this.calldata = result.data
        // :id="this.sensorid" :calldata="this.calldata" :type="this.type" :gid="this.gatewayid" 
        this.sensorid = this.calldata[0].sensorid
        // this.type = 'monnit'
        this.gatewayid = this.calldata[0].gatewayid
        // console.log(this.sensorid,this.type,this.gatewayid,this.calldata,this.lora)
        setTimeout( ()=> {
          this.$vs.loading.close()
        }, 100);
      })
    }else{
      console.log(this.$url+'sensordatashort/'+this.sensorid+'/'+this.gatewayid)
      this.$http.get(this.$url+'sensordatashort/'+this.sensorid+'/'+this.gatewayid).then((result) => {
        console.log(result.data)
        this.calldata = result.data
        if(this.type == 'aircon') {
          this.temp = this.calldata[0].temp
          this.fan = this.calldata[0].fan
          this.airmode = this.calldata[0].mode
        }
        if(this.type == 'advantech') {
          this.calldata.forEach(element => {
            // // console.log(element.t)
            element.Timestamp = this.$moment(element.t).format('YYYY-MM-DD HH:mm:ss');
            delete element.t;
            delete element.q;
            delete element.c;
            delete element.s;
          });
        }
        this.calldata.forEach(element => {
          delete element.users_id
        })
        setTimeout(()=> {
          this.$vs.loading.close()
        }, 100);
      }).catch((err) => {
        console.log(err)
      })
    }
  }
};
</script>
<style scoped>
img {
  max-width: 100%;
  height: auto;
}

.textRight {
    text-align: right;
  }
@media only screen and (max-width: 530px) {
  .textResponsive {
    text-align: left;
  }
}
</style>

